//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ServicesModal',
    data: function () {
        return {
            service: {},
            isAdditionalService: false
        }
    },

    props: {
        slug: {
            type: String,
            default: ""
        },
        ageSelected: {
            type: String,
            default: ""
        },
    },

    created: async function () {
        await this.loadService();
    },

    computed: {
        isShowImg() {
            return process.env.isShowImgAppointment === 'true';
        },
        // Стоимость услуги
        servicePrice: function () {
            if (!this.service.price || this.service.price === 0) {
                return "бесплатно";
            }

            return `${this.service.price} ₽`
        },

        // Длительность услуги
        serviceDuration: function () {
            const duration = this.service.duration;

            const hours = Math.floor(duration / 60);
            const minuts = duration - (hours * 60);

            return [
                !!hours ? `${hours} ${this.$caseWords(hours, ['час', 'часа', 'часов'])}` : undefined,
                !!minuts ? `${minuts} ${this.$caseWords(minuts, ['минута', 'минуты', 'минут'])}` : undefined,
            ].join(' ')
        },
        servicePrepare: function () {
        return this.service?.service_prepare || ''
      },

        // Допустимые возратные записи
        getAgeService: function () {
            let ages = [];

            if (this.service.for_children_2_6) {
                ages.push({label: "от 2 до 6 лет", value: "2-6"})
            }
            if (this.service.for_children_7_11) {
                ages.push({label: "от 7 до 11 лет", value: "7-11"})
            }
            if (this.service.for_children_12_18) {
                ages.push({label: "от 12 до 18 лет", value: "12-18"})
            }
            if (!this.service.for_children_12_18 && !this.service.for_children_12_18 && !this.service.for_children_2_6) {
                ages.push({label: "старше 18 лет", value: "19"})
            }

            return ages
        }

    },

    methods: {

        // Загрузка услугу
        loadService: async function () {
            const {data: service} = await this.$api.agent.transport.get(`services/${this.slug}`);

            this.$modal.show("service-card-modal");

            this.service = service;
        },

        // Запись на прием
        onMakeAppointment: function () {

        },

        // Закртие модального окна
        close: function () {
            this.service = {};
            this.$emit("close")
        },

        // Запись на прием
        click: function (age) {

            if(this.service?.category_id === 5) {
              this.isAdditionalService = true;
              return;
            }


            this.$emit('click', {
                serviceId: this.service.id,
                age: age.value,
                isConfirm: false
            });
            this.close();
        },

      // Запись на прием
      clickAdditionalServices: function () {
        let serviceId = 8;
        if (this.ageSelected === "2-6") {
          serviceId = 40;
        }
        if (this.ageSelected === "7-11") {
          serviceId = 42;
        }
        if (this.ageSelected === "12-18") {
          serviceId = 41;
        }
        this.$emit('click', {
          serviceId,
          age: this.ageSelected
        });
        this.isAdditionalService = false;
        this.close();
      }
    }

};
